import { put, call, takeLatest } from "redux-saga/effects";
import { flashMessage } from "redux-flash";
import axios from "axios";
import { push } from "react-router-redux";

import {
  PASSWORD_CHANGE_REQUEST,
  passwordChangeSuccess,
  passwordChangeError,
} from "./actions";
import { Env } from "../../env";

function* passwordChangeRequest(action) {
  const { password, passwordCheck, accessToken } = action;

  if (password !== passwordCheck) {
    yield put(passwordResetError("Les mots de passe ne correspondent pas."));

    return;
  }

  try {
    yield call(
      axios.post,
      `${Env.BASE_API_URL}/Accounts/reset-password`,
      {
        newPassword: password,
      },
      {
        headers: { Authorization: accessToken },
      }
    );
  } catch (err) {
    let error;
    if (err.response && err.response.status === 401) {
      error = "Lien expiré, veuillez renouveler la demande.";
    } else {
      error = "Une erreur s'est produite, veuillez réessayer.";
    }

    yield put(passwordChangeError());
    yield put(flashMessage(error));

    return;
  }

  yield put(passwordChangeSuccess());
  yield put(push("/updateprofile"));
  yield put(flashMessage("Mot de passe changez avec succès."));
}

export default function* watchPasswordChangeRequest() {
  yield takeLatest(PASSWORD_CHANGE_REQUEST, passwordChangeRequest);
}



// WEBPACK FOOTER //
// ./src/pages/password-change/saga.js